// Copyright © Veeam Software Group GmbH

import { createContext } from 'react';

import resourcesService from './ResourcesService';

export interface ResourcesContextState {
    resources: typeof resourcesService.current;
    toggleLang(langCode: string): void;
}

const ResourcesContext = createContext<ResourcesContextState>({
    resources: resourcesService.current,
    toggleLang: (langCode: string) => resourcesService.toggleLanguage(langCode),
});

// eslint-disable-next-line import/no-default-export
export default ResourcesContext;
